module.exports = __webpack_public_path__ + "static/media/qr_code_wechat.d654ebbf.png";